import { IPrivacyPolicy } from '@/types/cms';
import { NextSeo } from 'next-seo';
import React from 'react';
import { getPrivacyPolicy } from 'services/cmsService';
import { tryToNoticeError } from 'utils/errorInfo';

import { CMSChildrenContainer } from 'components/CMS/ChildrenContainer';
import { MarkdownContent } from 'components/CMS/MarkdownContent';
import { SingleCoverComponent } from 'components/CMS/SingleCoverComponent';

import { CMSContainer } from 'modules/CMSContainer';

interface PrivacyPolicyProps {
  data: IPrivacyPolicy;
}

const PrivacyPolicy = ({ data }: PrivacyPolicyProps) => {
  const { content, meta_title, meta_description, cover_collection, index } = data;

  return (
    <CMSContainer>
      <NextSeo
        title={meta_title}
        description={meta_description}
        openGraph={{
          title: meta_title,
          description: meta_description,
        }}
        noindex={!index}
        nofollow={!index}
      />
      <SingleCoverComponent {...cover_collection} />
      <CMSChildrenContainer>{content && <MarkdownContent source={content} />}</CMSChildrenContainer>
    </CMSContainer>
  );
};

export async function getServerSideProps(ctx) {
  try {
    const data = await getPrivacyPolicy();

    if (data?.redirect_url) {
      const { res } = ctx;
      if (res) {
        res.writeHead(301, { Location: data.redirect_url });
        res.end();
      }
    }

    return {
      props: { data },
    };
  } catch (error) {
    const errorMessage = `Privacy Policy Page Data Error: ${error.message}`;
    tryToNoticeError(new Error(errorMessage, { cause: error }), { error });
    return { notFound: true };
  }
}

export default PrivacyPolicy;
